import type { ReactNode } from 'react'
import type { SelectorParam } from 'i18next'
import { Cookie, Download, KeyRound, Library, Podcast, Rss, Ticket } from 'lucide-react'

// Единый источник пунктов основной навигации — используется и в TopBar (десктоп:
// текст + шорткат; промежуточная ширина 721–1220px: только иконки), и в нижней
// таб-навигации AppLayout (мобайл, только иконки).
// Иконки — lucide-react (outline, stroke=currentColor). Размер задаётся в CSS
// (`.bottom-nav__icon svg`, `.topbar__nav-icon svg`).
// Шорткаты — одни и те же латинские буквы во всех языках; переводится только подпись.
export interface NavItem {
  to: string
  // Селектор подписи: t() — при рендере, иначе язык замёрз бы на импорте модуля.
  label: SelectorParam
  shortcut: string
  icon: ReactNode
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/',
    label: ($) => $.nav.downloads,
    shortcut: '/',
    icon: <Download aria-hidden />,
  },
  {
    to: '/library',
    label: ($) => $.nav.library,
    shortcut: 'L',
    icon: <Library aria-hidden />,
  },
  {
    to: '/subscriptions',
    label: ($) => $.nav.subscriptions,
    shortcut: 'S',
    icon: <Podcast aria-hidden />,
  },
  {
    to: '/settings/feed',
    label: ($) => $.nav.feed,
    shortcut: 'F',
    icon: <Rss aria-hidden />,
  },
  {
    to: '/settings/tokens',
    label: ($) => $.nav.tokens,
    shortcut: 'T',
    icon: <Ticket aria-hidden />,
  },
  {
    to: '/settings/cookies',
    label: ($) => $.nav.cookies,
    shortcut: 'C',
    icon: <Cookie aria-hidden />,
  },
  {
    to: '/settings/security',
    label: ($) => $.nav.keys,
    shortcut: 'K',
    icon: <KeyRound aria-hidden />,
  },
]

export function getVisibleNavItems(): NavItem[] {
  return NAV_ITEMS
}
